import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgOnBudget = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path id="clipboard-plus" d="m17 4.25h-.27a2.036 2.036 0 0 0 -2.23-2h-5a2.036 2.036 0 0 0 -2.23 2h-.27a3.383 3.383 0 0 0 -3.75 3.75v10a3.383 3.383 0 0 0 3.75 3.75h10a3.383 3.383 0 0 0 3.75-3.75v-10a3.383 3.383 0 0 0 -3.75-3.75zm-8.25.25c0-.589.161-.75.75-.75h5c.589 0 .75.161.75.75v1c0 .589-.161.75-.75.75h-5c-.589 0-.75-.161-.75-.75zm10.5 13.5c0 1.577-.673 2.25-2.25 2.25h-10c-1.577 0-2.25-.673-2.25-2.25v-10c0-1.577.673-2.25 2.25-2.25h.27a2.036 2.036 0 0 0 2.23 2h5a2.036 2.036 0 0 0 2.23-2h.27c1.577 0 2.25.673 2.25 2.25zm-4-4.5a.75.75 0 0 1 -.75.75h-1.75v1.75a.75.75 0 0 1 -1.5 0v-1.75h-1.75a.75.75 0 0 1 0-1.5h1.75v-1.75a.75.75 0 0 1 1.5 0v1.75h1.75a.75.75 0 0 1 .75.75z" fill="inherit"/>
  </svg>
);
